module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waiter clear"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "TitleImg"
  }, [(_vm.headImg && _vm.headImg !== '') ? _c('img', {
    attrs: {
      "src": _vm.imgShowAddressFront + _vm.headImg + _vm.imgShowAddressEndFirst + "/w/50/h/50" + _vm.imgShowAddressEndSecond,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../../assets/img/yonghu/logo.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "row row1"
  }, [_c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.sex))])]), _vm._v(" "), (_vm.carName) ? _c('div', {
    staticClass: "row row3"
  }, [_c('span', {
    staticClass: "carName"
  }, [_vm._v("\n        " + _vm._s(_vm.carName) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "carColor"
  }, [_vm._v("\n        " + _vm._s(_vm.carColor) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.location) ? _c('div', {
    staticClass: "row row2"
  }, [_vm._v("\n      " + _vm._s(_vm.location) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.carNo) ? _c('div', {
    staticClass: "row row3"
  }, [_c('span', {
    staticClass: "carNo"
  }, [_vm._v("\n          " + _vm._s(_vm.carNo) + "\n        ")]), _vm._v(" "), (_vm.carType) ? _c('span', {
    staticClass: "waiterCarType"
  }, [_vm._v("\n          " + _vm._s(_vm.carType) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.paotuiType) ? _c('div', {
    staticClass: "row row3"
  }, [_c('span', {
    staticClass: "paotuiType"
  }, [_vm._v("\n          " + _vm._s(_vm.paotuiType) + "\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.phone) ? _c('span', {
    staticClass: "waiterPhone"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.phone
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dianhua1"
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72735702","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/waiter/src/waiter.vue
// module id = 546
// module chunks = 0